<div class="sorting-box">
    <nb-select [(selected)]="+selectedItem" (selectedChange)="sortBy()" size="small" status="primary">
        <nb-option *ngFor="let sort of sortingTypes | keyvalue" [value]="+sort.key">{{sort.value | translate}}</nb-option>
    </nb-select>
</div>